
export enum ButtonStatus {
    primary,
    secondary,
    success,
    danger,
    warning,
    info,
    light,
    dark,
    link,
    disabled,
    float,
    plain
}

export enum ButtonType {
    basic,
    outline,
    block
}

export enum ButtonSize {
    small,
    normal,
    lager,
}